import IJsonResponse from "@/utils/types/IJsonResponse";
import { EServices } from "@/types";
import { inject, injectable } from "tsyringe";
import HttpClient from "@/services/HttpClient";
import { IRank } from "../types";

@injectable()
export default class RanksClient {
  constructor(@inject(EServices.http) private http: HttpClient) {}

  async getCustomerRank(id: number): Promise<IRank> {
    const response = await this.http.get(`/v1/app/ranks/${id}`);
    return response.data;
  }
}
